<template>
  <div class="w-100">
    <vz-cargo-general :order-lock="disabled" />
    <div class="vz-individual-order-cargo-mode-cards">
      <vz-cargo-card
        v-for="(item, index) in placeItems"
        :key="item.key"
        :title="item.label"
        :disabled="isOnlyOne"
        @remove="removeCard(index)"
        @copy="copyCard(index)"
        @update:title="orderStore.orderForm.cargo.places.items[index].label = $event"
      >
        <vz-cargo-dimension
          :detail="getItem(index)"
          :wrapping="getItem(index).wrapping"
          :count="getItem(index).count"
          :disabled="disabled"
          has-count
          @change-detail-param="onChangeItemParam(index, $event)"
          @add-pallet="addModsWrapping(index)"
          @set-mode="setMode"
        />
      </vz-cargo-card>
    </div>
    <vz-cargo-hint />
    <vz-button
      icon-name="plus"
      variant="primary"
      outline
      big
      class="add-card-button"
      :disabled="disabled"
      @click="addCard"
    >
      Добавить
    </vz-button>
  </div>
</template>

<script setup lang="ts">
import {useWrappingStore} from '~/stores/wrapping';
import {modChecker, OrderWrappingModParameters} from '~/types/types';
import {useOrderStore} from '~/stores/order';
import VzCargoGeneral from '~/components/personal/order/cargo/parts/vz-cargo-general.vue';
import VzCargoCard from '~/components/personal/order/cargo/parts/vz-cargo-card.vue';
import VzCargoDimension from '~/components/personal/order/cargo/parts/vz-cargo-dimension.vue';
import VzCargoHint from '~/components/personal/order/cargo/parts/vz-cargo-hint.vue';
import {getModCheckFunction} from '~/common/functions';
import useOrderCargo from '~/composables/useOrderCargo';

const emit = defineEmits(['set-mode'])

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  }
})

const wrappingStore = useWrappingStore()
const orderStore = useOrderStore()
const {
  items: placeItems,
  isOnlyOne,
  getItem,
  addCard,
  copyCard,
  removeCard
} = useOrderCargo('places')

async function setMode(value: string) {
  if (value === 'pallets') {
    orderStore.orderForm.cargo.pallets.items = orderStore.orderForm.cargo.places.items
      ?.map(item => ({
        ...item,
        type: 'nonStandard'
      }))
  }
  emit('set-mode', value)
}

function modCheck(index: number) {
  const mod: modChecker = {
    weight: () => false,
    weightProperty: '',
    weightMessage: ''
  }

  const weight = wrappingStore.mods.find(item => item.mod.condition.cargo?.dimension?.detail.weight)
  if (weight) {
    mod.weight = (): boolean => {
      const fc = getModCheckFunction(Object.keys(weight.mod.condition.cargo?.dimension?.detail.weight as {'>=' : 1})[0] as
        OrderWrappingModParameters['conditions'])
      return fc(
        parseInt(orderStore.orderForm.cargo.places.items[index]?.weight as never as string),
        Object.values(weight.mod.condition.cargo?.dimension?.detail.weight as {'>=' : 1})[0]
      )
    }
    mod.weightProperty = weight.key
    mod.weightMessage = weight.mod.message
  }

  return mod
}

function validateWeight(index: number) {
  const mod = modCheck(index)
  const modWrapping = orderStore.orderForm.cargo.places.items[index].wrapping.find(item => item.code === mod.weightProperty)

  if (!mod.weight() && modWrapping) {
    orderStore.orderForm.cargo.places.items[index].wrapping = orderStore.orderForm.cargo.places.items[index].wrapping
      .filter(item => item.code !== mod.weightProperty)
  }
}

function addModsWrapping(index: number) {
  const modWrapping = orderStore.orderForm.cargo.places.items[index].wrapping.find(item => item.code === 'palletCustomer')
  if (!modWrapping) {
    orderStore.orderForm.cargo.places.items[index].wrapping.push({ code: 'palletCustomer', value: 1 })
    orderStore.getOrderPriceAction()
  }
}

function onChangeItemParam(index: number, { param, value }: { param: string, value: string | number }) {
  orderStore.orderForm.cargo.places.items[index][param] = +value
  if (param === 'weight') {
    validateWeight(index)
  }
  orderStore.getOrderPriceAction()
}
</script>
